/* eslint-disable camelcase */
import type { CandidateRegistration } from '@/types/candidateRegistration';
import type { ValuesType } from './types';

type MountRegisterObjTypes = {
  values: ValuesType;
  candidateApplicationId: string;
  cpfFileImageURL: string;
  selfieImageURL: string;
  proofOfAddressImageURL: string;
  rgFileImageURL: string;
  selectionProcessId: string;
};

const mountRegisterObj = (
  props: MountRegisterObjTypes,
): CandidateRegistration => {
  const {
    values,
    candidateApplicationId,
    cpfFileImageURL,
    selfieImageURL,
    proofOfAddressImageURL,
    rgFileImageURL,
    selectionProcessId,
  } = props;
  return {
    address: values.address,
    ...(values.address_complement && {
      address_complement: values.address_complement,
    }),
    birthdate: new Date(
      `${values.year}-${values.month}-${values.day}`,
    ).toISOString(),
    birthplace: values.birthplace,
    candidate_application_id: candidateApplicationId,
    city: values.city,
    cpf: values.cpf,
    ...(cpfFileImageURL && {
      cpf_document_url: cpfFileImageURL,
    }),
    ...(selfieImageURL && {
      document_selfie_url: selfieImageURL,
    }),
    marital_status: values.marital_status,
    monthly_income: values.monthlyIncome,
    name: values.name,
    nationality:
      values.nationality !== 'brasileira'
        ? values.nationalityOther
        : values.nationality,
    neighborhood: values.neighborhood,
    politically_exposed_person: Boolean(values.pep),
    ...(proofOfAddressImageURL && {
      proof_of_residency_document_url: proofOfAddressImageURL,
    }),
    residence_number: values.residence_number,
    residence_type: values.residence_type,
    rg: values.rg,
    ...(rgFileImageURL && {
      rg_document_url: rgFileImageURL,
    }),
    rg_issuing_body: values.rg_issuing_body,
    rg_issuing_state: values.rg_issuing_state,
    state: values.state,
    student_financing_check: values.studentFinance,
    zipcode: values.zipcode,
    selection_process_id: selectionProcessId,
  };
};

export default mountRegisterObj;
